<script setup>
	import DeleteIcon from "./DeleteIcon.vue";
	import { VBtn } from "vuetify/components";

	const props = defineProps({
		class: Array,
		disabled: Boolean
	});
	const emit = defineEmits([ "click" ]);

	function raiseClickEmit() {
		emit("click");
	}
</script>

<template>
	<VBtn title="Delete"
		color="danger"
		:class="props.class.concat(['mx-2', 'delete-action'])"
		:disabled="props.disabled"
		@click="raiseClickEmit">
		<DeleteIcon/>
	</VBtn>
</template>
